import { DateTime } from 'luxon'

import { digObject } from '@domain-group/javascript-utils'

import type { CommentModel, ConversationModel } from '@models/types'

type FormatCommentTime = {
  conversation: ConversationModel,
  lastComment: CommentModel,
}

const formatCommentTime = (params: FormatCommentTime) => {
  const { lastComment, conversation } = params

  const conversationDateTime = digObject(conversation, 'dates.created.date_time', '')
  const lastCommentDateTime = digObject(lastComment, 'dates.created.date_time', '')

  const returnDateTime = lastCommentDateTime
    ? DateTime.fromFormat(lastCommentDateTime, 'dd/MM/yyyy HH:mm')
    : DateTime.fromFormat(conversationDateTime, 'dd/MM/yyyy HH:mm')

  const currentDate = new Date()
  const currentDateTime = DateTime.fromJSDate(currentDate)

  return returnDateTime.hasSame(currentDateTime, 'day')
    ? returnDateTime.toFormat('h:mm a')
    : returnDateTime.toFormat('dd/MM/yyyy')
}

export default formatCommentTime
